import {
  getLeoUuid,
  LeoUUID,
  getList,
  LeoRPCRequest,
  LeoRPCResponse,
  LeoRPCError,
  LeoRPCResult,
  LeoRPC
} from "@surya-digital/leo-ts-types";
import { EmailTemplate, EmailTemplateDTO } from "./emailTemplate";
/* eslint-disable import/export */
export abstract class GetAllEmailTemplatesRPC implements
  LeoRPC<GetAllEmailTemplatesRPC.Request, GetAllEmailTemplatesRPC.Response, GetAllEmailTemplatesRPC.Errors.Errors>
{
  abstract execute(
    request: GetAllEmailTemplatesRPC.Request
  ): Promise<LeoRPCResult<GetAllEmailTemplatesRPC.Response, GetAllEmailTemplatesRPC.Errors.Errors>>;
}

export namespace GetAllEmailTemplatesRPC {

  export class InvalidRequestError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidRequestError";
    }
  }

  export interface RequestDTO {
    projectId: string;
  }
  
  export class Request implements LeoRPCRequest {
    readonly isGetAllEmailTemplatesRPCRequest: boolean = true;
  
    readonly projectId: LeoUUID;
  
  
    constructor(
    projectId: LeoUUID
    ) {
      this.projectId = projectId;
    }
  
    static fromDTO(dto: RequestDTO): Request {
      const projectId = getLeoUuid(dto, "projectId", InvalidRequestProjectIdError);
      return new Request(
        projectId
      );
    }
  
    toDTO(): RequestDTO {
      const dto: RequestDTO = {
          projectId: this.projectId.toDTO()
      };
      return dto;
    }
    }
  
  Request.prototype.toString = function toString(): string {
    return `GetAllEmailTemplatesRPC(projectId='${this.projectId}')`;
  };
  

  export class InvalidResponseError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidResponseError";
    }
  }

  export interface ResponseDTO {
    templates: EmailTemplateDTO[];
  }
  
  export class Response implements LeoRPCResponse {
    readonly isGetAllEmailTemplatesResponse: boolean = true;
  
    readonly templates: EmailTemplate[];
  
  
    constructor(
    templates: EmailTemplate[]
    ) {
      this.templates = templates;
    }
  
    static fromDTO(dto: ResponseDTO): Response {
      const templates = getList<EmailTemplateDTO, EmailTemplate>(
        dto,
        "templates",
        EmailTemplate.fromDTO,
        InvalidResponseTemplatesError
      );
      return new Response(
        templates
      );
    }
  
    toDTO(): ResponseDTO {
      const dto: ResponseDTO = {
          templates: this.templates.map((e: EmailTemplate) => { return e.toDTO() })
      };
      return dto;
    }
    }
  
  Response.prototype.toString = function toString(): string {
    return `GetAllEmailTemplates(templates='${this.templates}')`;
  };
  

  export enum RPCError {
    InvalidProjectId = "INVALID_PROJECT_ID"
  }

  export namespace Errors {
    
    export interface InvalidProjectIdDTO {
      code: string;
    }
    
    export class InvalidProjectId extends LeoRPCError<RPCError> {
      readonly isInvalidProjectId: boolean = true;
    
    
      constructor(
      ) {
        const code = RPCError.InvalidProjectId;
        super(code);
      }
    
    
      toDTO(): InvalidProjectIdDTO {
        const dto: InvalidProjectIdDTO = {
          code: this.code,
        };
        return dto;
      }
    
      }
    
    InvalidProjectId.prototype.toString = function toString(): string {
      return `GetAllEmailTemplatesRPC.INVALID_PROJECT_ID()`;
    };
    

    export type Errors = InvalidProjectId;
    export type ErrorsDTO = InvalidProjectIdDTO;

    export const fromDTO = (dto: ErrorsDTO): Errors => {
      switch (dto.code) {
        case RPCError.InvalidProjectId:
          return new InvalidProjectId();
        default:
          throw new InvalidResponseError(`Unexpected error code: ${dto.code}`);
      }
    };
  }
}

export class InvalidRequestProjectIdError extends GetAllEmailTemplatesRPC.InvalidRequestError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestProjectIdError";
  }
}

export class InvalidResponseTemplatesError extends GetAllEmailTemplatesRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseTemplatesError";
  }
}

export class InvalidResponseInvalidProjectIdError extends GetAllEmailTemplatesRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseInvalidProjectIdError";
  }
}

